import { Block } from 'webiq.boilerplate'

export default class Recovery extends Block {
	static title = 'recovery'

	init() {
		this.messageLength = this.getElement('message-length')
		this.messageCompare = this.getElement('message-compare')

		this.element.addEventListener('submit', e => {
			e.preventDefault()

			const password = this.element.querySelector('input[name="password[0]"]')
			const repeatPassword = this.element.querySelector('input[name="password[1]"]')

			const regex = /^(?=.*[0-9])(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~*]{8,}$/

			if (password.value.match(regex) && repeatPassword.value.match(regex)) {
				this.messageLength.classList.remove('recovery__message-length--active')
				if (password.value == repeatPassword.value) {
					this.messageCompare.classList.remove('recovery__message-compare--active')

					e.currentTarget.submit()
				} else {
					this.messageCompare.classList.add('recovery__message-compare--active')
					this.messageCompare.classList.add('recovery__message-compare--active-bold')
					setTimeout(() => {
						this.messageCompare.classList.remove('recovery__message-compare--active-bold')
					}, 1000)
				}
			} else {
				this.messageLength.classList.add('recovery__message-length--active')
				this.messageLength.classList.add('recovery__message-length--active-bold')
				setTimeout(() => {
					this.messageLength.classList.remove('recovery__message-length--active-bold')
				}, 1000)
			}
		})
	}
}
